// Mirror of backend/task_periods.py — AU periods computed dynamically (no hardcoded year lists).
// Keys: fy:<end_year> | q:<fy_end_year>:<1-4> | m:<YYYY>-<MM> | fbt:<end_year>
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const FREQUENCY = { financial_year: 'Annual', quarter: 'Quarterly', month: 'Monthly', fbt_year: 'FBT year' };

const pad = (n) => String(n).padStart(2, '0');
const iso = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;
const lastDay = (y, m) => new Date(y, m, 0).getDate();
export const fyCanonical = (end) => `${end - 1}-${String(end).slice(-2)}`;
export const fyLabel = (end) => `FY${fyCanonical(end)}`;
export const fyEndFor = (d = new Date()) => (d.getMonth() >= 6 ? d.getFullYear() + 1 : d.getFullYear());

export function periodFromKey(key) {
  const [kind, a, b] = (key || '').split(':');
  let start; let end; let label;
  if (kind === 'fy') {
    const y = Number(a); start = iso(y - 1, 7, 1); end = iso(y, 6, 30); label = fyLabel(y);
  } else if (kind === 'q') {
    const fy = Number(a); const n = Number(b); const y = n <= 2 ? fy - 1 : fy; const m0 = { 1: 7, 2: 10, 3: 1, 4: 4 }[n];
    start = iso(y, m0, 1); end = iso(y, m0 + 2, lastDay(y, m0 + 2)); label = `${MON[m0 - 1]}–${MON[m0 + 1]} ${y}`;
  } else if (kind === 'm') {
    const [y, m] = a.split('-').map(Number); start = iso(y, m, 1); end = iso(y, m, lastDay(y, m)); label = `${MONTH[m - 1]} ${y}`;
  } else if (kind === 'fbt') {
    const y = Number(a); start = iso(y - 1, 4, 1); end = iso(y, 3, 31); label = `FBT year ending 31 Mar ${y}`;
  } else return null;
  const [ey, em] = end.split('-').map(Number);
  return { key, label, start, end, financial_year: fyCanonical(em >= 7 ? ey + 1 : ey) };
}

export const fyOfKey = (key) => {
  const [kind, a] = (key || '').split(':');
  if (kind === 'fy' || kind === 'q') return Number(a);
  if (kind === 'm') { const [y, m] = a.split('-').map(Number); return m >= 7 ? y + 1 : y; }
  return null;
};

export function yearWindow(cur) { return [cur - 2, cur - 1, cur, cur + 1]; }

// Options for a period type within FY `fyEnd` (FY/FBT: previous 2, current, next 1).
export function periodOptions(type, fyEnd, today = new Date()) {
  const cur = fyEndFor(today);
  const fy = fyEnd || cur;
  if (type === 'financial_year') return yearWindow(cur).map((y) => periodFromKey(`fy:${y}`));
  if (type === 'quarter') return [1, 2, 3, 4].map((n) => periodFromKey(`q:${fy}:${n}`));
  if (type === 'month') return [7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6].map((m) => periodFromKey(`m:${m >= 7 ? fy - 1 : fy}-${pad(m)}`));
  if (type === 'fbt_year') { const f = today.getMonth() >= 3 ? today.getFullYear() + 1 : today.getFullYear(); return yearWindow(f).map((y) => periodFromKey(`fbt:${y}`)); }
  return [];
}

export function currentKey(type, today = new Date()) {
  const cur = fyEndFor(today); const m = today.getMonth() + 1;
  if (type === 'financial_year') return `fy:${cur}`;
  if (type === 'quarter') return `q:${cur}:${m >= 7 && m <= 9 ? 1 : m >= 10 ? 2 : m <= 3 ? 3 : 4}`;
  if (type === 'month') return `m:${today.getFullYear()}-${pad(m)}`;
  if (type === 'fbt_year') return `fbt:${m >= 4 ? today.getFullYear() + 1 : today.getFullYear()}`;
  return '';
}

export function buildTaskTitle(pattern, client, template, period) {
  const s = (pattern || '{client} – {template} – {period}').replace('{client}', client || '').replace('{template}', template || '').replace('{period}', period || '');
  return s.split(' – ').map((x) => x.trim()).filter(Boolean).join(' – ');
}
